import { getIcon, portalLink } from '@monash/portal-frontend-common';
import c from './available-applications.module.scss';
import { ExternalLink } from '@monash/portal-react';

const AppLink = ({ icon, name, url }) => (
  <div className={c.link}>
    <div className={c.appName}>
      <span>{icon}</span>
      <span>{name}</span>
    </div>
    <ExternalLink text="Visit" link={url} mode="card" variant="text" />
  </div>
);

const AvailableApplications = () => {
  return (
    <div className={c.applications}>
      <h2>Available applications</h2>
      <div className={c.links}>
        <AppLink
          name="Portal Home"
          url={portalLink('home')}
          icon={getIcon('Home')}
        />
        <AppLink
          name="Monash Links"
          url={portalLink('links')}
          icon={getIcon('Links')}
        />
        <AppLink
          name="Profile"
          url={portalLink('profile')}
          icon={getIcon('Profile')}
        />
      </div>
    </div>
  );
};

export default AvailableApplications;
